import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import Swal from 'sweetalert2';


import { UsuarioService } from '../services/service.index';
import { Usuario } from '../models/usuario.model';
import { Router, ActivatedRoute } from '@angular/router';



declare function init_plugins();
@Component({
  standalone: false,
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./login.component.css']
 
})
export class ChangepasswordComponent implements OnInit {
  forma: FormGroup;
  usuario=new Usuario();
  loadRegister:boolean=false;
  email:string="";
  token:string="";
  textoRegistrar:String="Cambiar";
  constructor(
    public router: Router,
    public _usuariService:UsuarioService,
    private route: ActivatedRoute,
    
  ) { }
  sonIguales( campo1: string, campo2: string ) {

    return ( group: FormGroup ) => {

      let pass1 = group.controls[campo1].value;
      let pass2 = group.controls[campo2].value;

      if ( pass1 === pass2 ) {
        return null;
      }

      return {
        sonIguales: true
      };

    };

  }
  ngOnInit() {
    init_plugins();
    let parm = this.route.snapshot.paramMap.get('token');
    this.token=parm;
    this.validaLink(parm)
    this.forma = new FormGroup({     
      password: new FormControl( null , Validators.required ),
      password2: new FormControl( null , Validators.required )
    }, { validators: this.sonIguales( 'password', 'password2' )  } );
  }

  validaLink(tocken:string){
    this._usuariService.buscaSiTockenActivo(tocken).subscribe( resp => {                
      if(resp.estado == 1){

      }else{
        this.router.navigate(['/login'])
      }
    },error=>{
      Swal.fire('Error en servicio', 'Servicio inactivo', 'error');   
      this.router.navigate(['/login'])
    });
  }
  updatePassword(){
    this.textoRegistrar="Cargando";
    this.loadRegister=true;
    if ( this.forma.invalid ) {
    this.loadRegister=false;
      return;
    }
    this._usuariService.updatePassword(this.token,this.forma.value.password).subscribe( resp => {                
      if(resp.estado==1){         
        Swal.fire('Contraseña actualizada', 'Ya puede iniciar sesión con su nueva contraseña.', 'success');
        this.router.navigate(['/login'])
        this.loadRegister=false;
        this.textoRegistrar="Cambiar";  
      }else{
        this.textoRegistrar="Cambiar";   
        this.loadRegister=false;
      }
    },error=>{
      Swal.fire('Error en servicio', 'Servicio inactivo', 'error');   
      this.router.navigate(['/login'])
    });
  }


}
